(function() {
'use strict';

// ===== CONFIGURAÇÕES — lidas do objeto global injetado pelo Liquid =====
var cfg = window.AmordidaOferta || {};
var META_FRETE_GRATIS = cfg.metaBrinde || 29900;
var BRINDE_HANDLE = cfg.brindeHandle || 'brd-esp-br-100';
var BRINDE_VARIANT_ID = cfg.brindeVariantId || '53687125606714';
var BRINDE_ATIVO = cfg.ativa !== false;

// ===== DEBOUNCE MAP =====
var pendingUpdates = {};

// ===== FLAG pra evitar loop de sincronização do brinde =====
var sincronizandoBrinde = false;

// ===== FORMATAÇÃO =====
function formatMoney(cents) {
  return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
}

// ===== CART API =====
function fetchCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}

function addToCart(variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  }).then(function(r) { return r.json(); });
}

function updateQuantity(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function(r) {
    return r.json().then(function(data) {
      if (!r.ok || data.status) throw data;
      return data;
    });
  });
}

function removeItem(key) {
  return updateQuantity(key, 0);
}

// ===== BRINDE =====
function getBrindeItem(cart) {
  return cart.items.find(function(item) {
    return item.handle === BRINDE_HANDLE ||
           String(item.variant_id) === BRINDE_VARIANT_ID;
  });
}

function sincronizarBrinde(cart) {
  if (sincronizandoBrinde) return Promise.resolve(null);

  // Se oferta desligada, remove brinde se existir
  if (!BRINDE_ATIVO) {
    var brindeExistente = getBrindeItem(cart);
    if (brindeExistente) {
      sincronizandoBrinde = true;
      return removeItem(brindeExistente.key).then(function(c) {
        sincronizandoBrinde = false;
        return c;
      });
    }
    return Promise.resolve(null);
  }

  var brindeItem = getBrindeItem(cart);
  var temBrinde = !!brindeItem;
  var deveTermrinde = cart.total_price >= META_FRETE_GRATIS;

  // Qty > 1 — forçar 1
  if (temBrinde && brindeItem.quantity > 1) {
    sincronizandoBrinde = true;
    return updateQuantity(brindeItem.key, 1).then(function() {
      sincronizandoBrinde = false;
      return fetchCart();
    });
  }

  // Não tem mas deveria
  if (!temBrinde && deveTermrinde) {
    sincronizandoBrinde = true;
    return addToCart(BRINDE_VARIANT_ID, 1).then(function() {
      sincronizandoBrinde = false;
      return fetchCart();
    }).catch(function() {
      sincronizandoBrinde = false;
      return null;
    });
  }

  // Tem mas não deveria
  if (temBrinde && !deveTermrinde) {
    sincronizandoBrinde = true;
    return removeItem(brindeItem.key).then(function(cart) {
      sincronizandoBrinde = false;
      return cart;
    });
  }

  return Promise.resolve(null);
}

// ===== MENSAGEM TEMPORÁRIA =====
function showCartMessage(message) {
  var bar = document.getElementById('amordida-frete-bar');
  if (!bar) return;
  bar.innerHTML = '<div class="amordida-cart-alert">' + message + '</div>';
  setTimeout(function() { refreshCart(); }, 1800);
}

// ===== ESTADO VAZIO / CHEIO =====
function toggleCartState(itemCount) {
  var freteBar = document.getElementById('amordida-frete-bar');
  var freteHeader = document.getElementById('amordida-frete-header');
  var footer = document.querySelector('.amordida-cart-drawer__footer');
  var upsell = document.getElementById('amordida-upsell-wrap');

  if (itemCount === 0) {
    if (freteBar) freteBar.style.display = 'none';
    if (freteHeader) freteHeader.style.display = 'none';
    if (footer) footer.style.display = 'none';
    if (upsell) upsell.style.display = 'none';
  } else {
    if (freteBar) freteBar.style.display = '';
    if (freteHeader) freteHeader.style.display = 'none';
    if (footer) footer.style.display = '';
  }
}

// ===== OPTIMISTIC QTY UPDATE =====
function changeQtyOptimistic(key, delta) {
  var item = document.querySelector('.amordida-cart-item[data-key="' + key + '"]');
  if (!item) return;

  var numEl = item.querySelector('.amordida-cart-item__qty-num');
  if (!numEl) return;

  var currentQty = parseInt(numEl.textContent) || 0;
  var novaQty = currentQty + delta;
  if (novaQty < 0) novaQty = 0;

  numEl.textContent = novaQty;
  numEl.classList.add('amordida-cart-item__qty-num--syncing');

  var precoEl = item.querySelector('.amordida-cart-item__preco');
  var precoUnit = parseInt(item.dataset.price) || 0;
  if (precoEl) precoEl.textContent = formatMoney(precoUnit * novaQty);

  var compareEl = item.querySelector('.amordida-cart-item__preco-compare');
  if (compareEl) {
    var compareUnit = parseInt(item.dataset.comparePrice) || 0;
    if (compareUnit) compareEl.textContent = formatMoney(compareUnit * novaQty);
  }

  var btnMinus = item.querySelector('.amordida-cart-item__qty-btn[data-action="minus"]');
  if (btnMinus) btnMinus.disabled = novaQty <= 1;

  if (!pendingUpdates[key]) pendingUpdates[key] = {};
  pendingUpdates[key].qty = novaQty;

  if (pendingUpdates[key].timer) clearTimeout(pendingUpdates[key].timer);

  pendingUpdates[key].timer = setTimeout(function() {
    var finalQty = pendingUpdates[key].qty;
    delete pendingUpdates[key];
    numEl.classList.remove('amordida-cart-item__qty-num--syncing');

    if (finalQty === 0) {
      removeItem(key).then(function(cart) {
        return sincronizarBrinde(cart).then(function() { refreshCart(); });
      });
    } else {
      updateQuantity(key, finalQty).then(function(cart) {
        return sincronizarBrinde(cart).then(function(cartAtualizado) {
          var cartFinal = cartAtualizado || cart;
          renderSubtotal(cartFinal);
          updateFreteBar(cartFinal);
          if (cartAtualizado) renderItems(cartFinal);
        });
      }).catch(function(error) {
        var msg = 'Quantidade máxima disponível em estoque.';
        if (error && error.description) msg = error.description;
        else if (error && error.message) msg = error.message;
        showCartMessage(msg);
      });
    }
  }, 600);
}

// ===== BARRA DE FRETE GRÁTIS =====
function updateFreteBar(cart) {
  var bar = document.getElementById('amordida-frete-bar');
  if (!bar) return;

  var total = cart.total_price;
  var faltam = META_FRETE_GRATIS - total;
  var progresso = Math.min((total / META_FRETE_GRATIS) * 100, 100);

  if (cart.item_count === 0) {
    bar.innerHTML = '';
    bar.style.display = 'none';
    return;
  }

  if (total >= META_FRETE_GRATIS) {
    bar.innerHTML =
      '<div class="amordida-frete-gratis">' +
        '<div class="amordida-frete-gratis__msg amordida-frete-gratis__msg--ok">🎉 ' + (BRINDE_ATIVO ? 'Frete grátis + petisco desbloqueados!' : 'Frete grátis desbloqueado!') + '</div>' +
        '<div class="amordida-frete-gratis__track">' +
          '<div class="amordida-frete-gratis__fill" style="width:100%"></div>' +
        '</div>' +
      '</div>';
    return;
  }

  bar.innerHTML =
    '<div class="amordida-frete-gratis">' +
      '<div class="amordida-frete-gratis__msg">🚚 Faltam <strong>' + formatMoney(faltam) + '</strong> para frete grátis' + (BRINDE_ATIVO ? ' + petisco' : '') + '</div>' +
      '<div class="amordida-frete-gratis__track">' +
        '<div class="amordida-frete-gratis__fill" style="width:' + progresso + '%"></div>' +
      '</div>' +
    '</div>';
}

// ===== RENDERIZA ITENS =====
function renderItems(cart) {
  var list = document.getElementById('amordida-cart-items');
  if (!list) return;

  toggleCartState(cart.item_count);

  if (cart.item_count === 0) {
    list.innerHTML =
      '<div class="amordida-cart__vazio">' +
        '<div class="amordida-cart__vazio-icone">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#E73363" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
            '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
          '</svg>' +
        '</div>' +
        '<p class="amordida-cart__vazio-titulo">Seu carrinho está vazio</p>' +
        '<p class="amordida-cart__vazio-subtitulo">Que tal nutrir seu cão da forma mais completa?</p>' +
      '</div>';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    var ehBrinde = item.handle === BRINDE_HANDLE || String(item.variant_id) === BRINDE_VARIANT_ID;
    var assinatura = item.selling_plan_allocation ? true : false;

    if (ehBrinde) {
      html +=
        '<div class="amordida-cart-item amordida-cart-item--brinde" data-key="' + item.key + '">' +
          '<div class="amordida-cart-item__img-wrap">' +
            '<img src="' + item.image + '" alt="' + item.title + '" class="amordida-cart-item__img">' +
          '</div>' +
          '<div class="amordida-cart-item__info">' +
            '<div class="amordida-cart-item__header">' +
              '<p class="amordida-cart-item__nome">' + item.product_title + '</p>' +
              '<span class="amordida-cart-item__tag-brinde">🎁 Brinde</span>' +
            '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="amordida-cart-item__variante">' + item.variant_title + '</p>' : '') +
            '<div class="amordida-cart-item__footer">' +
              '<p class="amordida-cart-item__brinde-obs">Adicionado automaticamente</p>' +
              '<span class="amordida-cart-item__preco amordida-cart-item__preco--gratis">Grátis</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    } else {
      html +=
        '<div class="amordida-cart-item" data-key="' + item.key + '" data-price="' + item.price + '" data-compare-price="' + (item.properties && item.properties['_compare_at_price'] ? item.properties['_compare_at_price'] : 0) + '">' +
          '<a href="' + item.url + '" class="amordida-cart-item__img-wrap">' +
            '<img src="' + item.image + '" alt="' + item.title + '" class="amordida-cart-item__img">' +
          '</a>' +
          '<div class="amordida-cart-item__info">' +
            '<div class="amordida-cart-item__header">' +
              '<p class="amordida-cart-item__nome">' + item.product_title + '</p>' +
              '<button class="amordida-cart-item__remover" data-key="' + item.key + '" aria-label="Remover">✕</button>' +
            '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="amordida-cart-item__variante">' + item.variant_title + '</p>' : '') +
            (assinatura ? '<span class="amordida-cart-item__tag-assinatura">Assinatura</span>' : '') +
            '<div class="amordida-cart-item__footer">' +
              '<div class="amordida-cart-item__qty">' +
                '<button class="amordida-cart-item__qty-btn" data-key="' + item.key + '" data-action="minus"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
                '<span class="amordida-cart-item__qty-num">' + item.quantity + '</span>' +
                '<button class="amordida-cart-item__qty-btn" data-key="' + item.key + '" data-action="plus">+</button>' +
              '</div>' +
              '<div class="amordida-cart-item__preco-wrap">' +
                (item.properties && item.properties['_compare_at_price'] ? '<span class="amordida-cart-item__preco-compare">' + formatMoney(item.properties['_compare_at_price']) + '</span>' : '') +
                '<span class="amordida-cart-item__preco">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }
  });

  list.innerHTML = html;

  list.querySelectorAll('.amordida-cart-item__remover').forEach(function(btn) {
    btn.addEventListener('click', function() {
      removeItem(btn.dataset.key).then(function(cart) {
        return sincronizarBrinde(cart).then(function() { refreshCart(); });
      });
    });
  });

  list.querySelectorAll('.amordida-cart-item__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      changeQtyOptimistic(btn.dataset.key, btn.dataset.action === 'plus' ? 1 : -1);
    });
  });
}

// ===== SUBTOTAL E CONTADOR =====
function renderSubtotal(cart) {
  var el = document.getElementById('amordida-cart-subtotal');
  if (el) el.textContent = formatMoney(cart.total_price);

  var contador = document.getElementById('amordida-cart-count');
  if (contador) contador.textContent = cart.item_count;

  var cartIcon = document.querySelector('cart-icon');
  if (cartIcon) {
    cartIcon.setAttribute('data-cart-count', cart.item_count);
    var bubble = cartIcon.querySelector('.cart-bubble');
    var count = cartIcon.querySelector('.cart-bubble__text-count');
    if (cart.item_count > 0) {
      if (bubble) bubble.classList.remove('visually-hidden');
      if (count) { count.classList.remove('hidden'); count.textContent = cart.item_count; }
    } else {
      if (bubble) bubble.classList.add('visually-hidden');
      if (count) count.classList.add('hidden');
    }
  }
}

// ===== REFRESH COMPLETO =====
function refreshCart() {
  fetchCart().then(function(cart) {
    return sincronizarBrinde(cart).then(function(cartAtualizado) {
      var cartFinal = cartAtualizado || cart;
      renderItems(cartFinal);
      renderSubtotal(cartFinal);
      updateFreteBar(cartFinal);
    });
  });
}

// ===== DRAWER OPEN/CLOSE =====
function abrirDrawer() {
  var drawer = document.getElementById('amordida-cart-drawer');
  var overlay = document.getElementById('amordida-cart-overlay');
  if (!drawer) return;
  drawer.classList.add('amordida-cart-drawer--open');
  if (overlay) overlay.classList.add('amordida-cart-overlay--open');
  document.documentElement.style.overflow = 'hidden';
  refreshCart();
}

function fecharDrawer() {
  var drawer = document.getElementById('amordida-cart-drawer');
  var overlay = document.getElementById('amordida-cart-overlay');
  if (!drawer) return;
  drawer.classList.remove('amordida-cart-drawer--open');
  if (overlay) overlay.classList.remove('amordida-cart-overlay--open');
  document.documentElement.style.overflow = '';
}

window.amordidaCartAbrir = abrirDrawer;
window.amordidaCartFechar = fecharDrawer;

// ===== INIT =====
document.addEventListener('DOMContentLoaded', function() {

  var overlay = document.getElementById('amordida-cart-overlay');
  if (overlay) overlay.addEventListener('click', fecharDrawer);

  var btnFechar = document.getElementById('amordida-cart-fechar');
  if (btnFechar) btnFechar.addEventListener('click', fecharDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') fecharDrawer();
  });

  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('pdpVariantId').value;
      var btn = document.getElementById('pdpAddToCart');
      if (btn) { btn.textContent = 'Adicionando...'; btn.disabled = true; }
      addToCart(variantId, 1).then(function() {
        if (btn) { btn.textContent = 'Comprar'; btn.disabled = false; }
        abrirDrawer();
      }).catch(function() {
        if (btn) { btn.textContent = 'Comprar'; btn.disabled = false; }
      });
    });
  }

  refreshCart();
});

})();